// extracted by mini-css-extract-plugin
export default {"UploadButton":"uploadbutton_UploadButton__rYFWL"};